import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <div className="footer-container">
        <motion.div 
          className="footer-content"
          initial={{ y: 20 }}
          whileInView={{ y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h3>MAMY BRAND</h3>
          <p className="footer-desc">
            رواد في تصنيع وإنتاج الملابس العصرية بأعلى معايير الجودة والخامات المميزة لتلبي كل تطلعاتك وتمنحك إطلالة فريدة ومميزة.
          </p>
          
         
          <div className="copyright">
            <p>© {new Date().getFullYear()} MAMY BRAND. جميع الحقوق محفوظة.</p>
            <p className="developer-credit">تم التطوير بواسطة Ziad Hamada</p>
          </div>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;